module.exports = __webpack_public_path__ + "static/media/execute_concept_application.38d50268.png";